import { render, staticRenderFns } from "./routeItem.vue?vue&type=template&id=2c37cf1e&scoped=true&"
import script from "./routeItem.vue?vue&type=script&lang=js&"
export * from "./routeItem.vue?vue&type=script&lang=js&"
import style0 from "./routeItem.vue?vue&type=style&index=0&id=2c37cf1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37cf1e",
  null
  
)

export default component.exports